/** This file is auto generated by convertSvgToJsx.ts */

import above_the_line from './above_the_line'
import above_the_line_medium from './above_the_line_medium'
import account from './account'
import account_card from './account_card'
import account_card_medium from './account_card_medium'
import account_in from './account_in'
import account_in_medium from './account_in_medium'
import account_medium from './account_medium'
import account_out from './account_out'
import account_out_medium from './account_out_medium'
import account_percent from './account_percent'
import account_percent_medium from './account_percent_medium'
import accounting from './accounting'
import accounting_medium from './accounting_medium'
import add from './add'
import add_circled from './add_circled'
import add_circled_medium from './add_circled_medium'
import add_medium from './add_medium'
import aino from './aino'
import aino_medium from './aino_medium'
import ainvoice from './ainvoice'
import ainvoice_medium from './ainvoice_medium'
import ambulance from './ambulance'
import ambulance_medium from './ambulance_medium'
import animal_print from './animal_print'
import animal_print_medium from './animal_print_medium'
import apple_watch from './apple_watch'
import apple_watch_medium from './apple_watch_medium'
import arrow_down from './arrow_down'
import arrow_down_medium from './arrow_down_medium'
import arrow_left from './arrow_left'
import arrow_left_medium from './arrow_left_medium'
import arrow_right from './arrow_right'
import arrow_right_medium from './arrow_right_medium'
import arrow_up from './arrow_up'
import arrow_up_medium from './arrow_up_medium'
import attachment from './attachment'
import attachment_medium from './attachment_medium'
import baby from './baby'
import baby_medium from './baby_medium'
import bandage from './bandage'
import bandage_medium from './bandage_medium'
import bank from './bank'
import bank_medium from './bank_medium'
import bankid from './bankid'
import bankid_medium from './bankid_medium'
import bankid_mobile from './bankid_mobile'
import bankid_mobile_medium from './bankid_mobile_medium'
import bankid_qr from './bankid_qr'
import bankid_qr_medium from './bankid_qr_medium'
import bell from './bell'
import bell_medium from './bell_medium'
import bicycle from './bicycle'
import bicycle_medium from './bicycle_medium'
import boat from './boat'
import boat_medium from './boat_medium'
import bookmark from './bookmark'
import bookmark_medium from './bookmark_medium'
import bowling from './bowling'
import bowling_medium from './bowling_medium'
import brickwall from './brickwall'
import brickwall_medium from './brickwall_medium'
import broken_chain from './broken_chain'
import broken_chain_medium from './broken_chain_medium'
import browser from './browser'
import browser_medium from './browser_medium'
import brush from './brush'
import brush_medium from './brush_medium'
import bsu from './bsu'
import bsu_medium from './bsu_medium'
import bubble from './bubble'
import bubble_medium from './bubble_medium'
import building_construction from './building_construction'
import building_construction_medium from './building_construction_medium'
import building_shopping from './building_shopping'
import building_shopping_medium from './building_shopping_medium'
import bus from './bus'
import bus_medium from './bus_medium'
import calculator from './calculator'
import calculator_medium from './calculator_medium'
import calendar from './calendar'
import calendar_add from './calendar_add'
import calendar_add_medium from './calendar_add_medium'
import calendar_cancel from './calendar_cancel'
import calendar_cancel_medium from './calendar_cancel_medium'
import calendar_medium from './calendar_medium'
import camera from './camera'
import camera_medium from './camera_medium'
import camper_trailer from './camper_trailer'
import camper_trailer_medium from './camper_trailer_medium'
import candle_stick from './candle_stick'
import candle_stick_medium from './candle_stick_medium'
import car_1 from './car_1'
import car_1_medium from './car_1_medium'
import car_2 from './car_2'
import car_2_medium from './car_2_medium'
import caravan from './caravan'
import caravan_medium from './caravan_medium'
import card from './card'
import card_in from './card_in'
import card_in_medium from './card_in_medium'
import card_medium from './card_medium'
import card_out from './card_out'
import card_out_medium from './card_out_medium'
import card_with_padlock from './card_with_padlock'
import card_with_padlock_medium from './card_with_padlock_medium'
import cat from './cat'
import cat_medium from './cat_medium'
import chain from './chain'
import chain_medium from './chain_medium'
import charger from './charger'
import charger_medium from './charger_medium'
import chat from './chat'
import chat_medium from './chat_medium'
import chatbot from './chatbot'
import chatbot_medium from './chatbot_medium'
import check from './check'
import check_medium from './check_medium'
import chevron_down from './chevron_down'
import chevron_down_medium from './chevron_down_medium'
import chevron_left from './chevron_left'
import chevron_left_medium from './chevron_left_medium'
import chevron_right from './chevron_right'
import chevron_right_medium from './chevron_right_medium'
import chevron_up from './chevron_up'
import chevron_up_medium from './chevron_up_medium'
import chip from './chip'
import chip_medium from './chip_medium'
import clock from './clock'
import clock_medium from './clock_medium'
import close from './close'
import close_medium from './close_medium'
import cloud from './cloud'
import cloud_download from './cloud_download'
import cloud_download_medium from './cloud_download_medium'
import cloud_medium from './cloud_medium'
import cloud_rain from './cloud_rain'
import cloud_rain_medium from './cloud_rain_medium'
import cloud_sync from './cloud_sync'
import cloud_sync_medium from './cloud_sync_medium'
import cloud_transfer from './cloud_transfer'
import cloud_transfer_medium from './cloud_transfer_medium'
import cloud_upload from './cloud_upload'
import cloud_upload_medium from './cloud_upload_medium'
import cog from './cog'
import cog_medium from './cog_medium'
import coins_1 from './coins_1'
import coins_1_medium from './coins_1_medium'
import coins_2 from './coins_2'
import coins_2_medium from './coins_2_medium'
import coins_3 from './coins_3'
import coins_3_medium from './coins_3_medium'
import compose from './compose'
import compose_medium from './compose_medium'
import confetti from './confetti'
import confetti_medium from './confetti_medium'
import contacts from './contacts'
import contacts_medium from './contacts_medium'
import cookie from './cookie'
import cookie_medium from './cookie_medium'
import copy from './copy'
import copy_medium from './copy_medium'
import credit_note from './credit_note'
import credit_note_medium from './credit_note_medium'
import currency from './currency'
import currency_medium from './currency_medium'
import customer_service from './customer_service'
import customer_service_medium from './customer_service_medium'
import deleted_invoice from './deleted_invoice'
import deleted_invoice_medium from './deleted_invoice_medium'
import diamond from './diamond'
import diamond_medium from './diamond_medium'
import digipass from './digipass'
import digipass_corporate from './digipass_corporate'
import digipass_corporate_medium from './digipass_corporate_medium'
import digipass_medium from './digipass_medium'
import digipass_private from './digipass_private'
import digipass_private_medium from './digipass_private_medium'
import digipost from './digipost'
import digipost_medium from './digipost_medium'
import digital_advise from './digital_advise'
import digital_advise_medium from './digital_advise_medium'
import digitpass_private_corporate from './digitpass_private_corporate'
import digitpass_private_corporate_medium from './digitpass_private_corporate_medium'
import dismiss_keyboard from './dismiss_keyboard'
import dismiss_keyboard_medium from './dismiss_keyboard_medium'
import dog from './dog'
import dog_medium from './dog_medium'
import download from './download'
import download_medium from './download_medium'
import e_scooter from './e_scooter'
import e_scooter_medium from './e_scooter_medium'
import edit from './edit'
import edit_medium from './edit_medium'
import einvoice from './einvoice'
import einvoice_medium from './einvoice_medium'
import email from './email'
import email_medium from './email_medium'
import envelope_open from './envelope_open'
import envelope_open_medium from './envelope_open_medium'
import equities_and_mutual_funds from './equities_and_mutual_funds'
import equities_and_mutual_funds_medium from './equities_and_mutual_funds_medium'
import exclamation from './exclamation'
import exclamation_circled from './exclamation_circled'
import exclamation_circled_medium from './exclamation_circled_medium'
import exclamation_medium from './exclamation_medium'
import exclamation_triangle from './exclamation_triangle'
import exclamation_triangle_medium from './exclamation_triangle_medium'
import facebook from './facebook'
import facebook_medium from './facebook_medium'
import factory from './factory'
import factory_medium from './factory_medium'
import file from './file'
import file_add from './file_add'
import file_add_medium from './file_add_medium'
import file_contract from './file_contract'
import file_contract_medium from './file_contract_medium'
import file_csv from './file_csv'
import file_csv_medium from './file_csv_medium'
import file_jpg from './file_jpg'
import file_jpg_medium from './file_jpg_medium'
import file_loupe from './file_loupe'
import file_loupe_medium from './file_loupe_medium'
import file_medium from './file_medium'
import file_pdf from './file_pdf'
import file_pdf_medium from './file_pdf_medium'
import file_png from './file_png'
import file_png_medium from './file_png_medium'
import file_ppt from './file_ppt'
import file_ppt_medium from './file_ppt_medium'
import file_rejected from './file_rejected'
import file_rejected_medium from './file_rejected_medium'
import file_signing from './file_signing'
import file_signing_medium from './file_signing_medium'
import file_txt from './file_txt'
import file_txt_medium from './file_txt_medium'
import file_warning from './file_warning'
import file_warning_medium from './file_warning_medium'
import file_word from './file_word'
import file_word_medium from './file_word_medium'
import file_xls from './file_xls'
import file_xls_medium from './file_xls_medium'
import file_xml from './file_xml'
import file_xml_medium from './file_xml_medium'
import file_zip from './file_zip'
import file_zip_medium from './file_zip_medium'
import filter from './filter'
import filter_medium from './filter_medium'
import first_aid from './first_aid'
import first_aid_medium from './first_aid_medium'
import fish from './fish'
import fish_medium from './fish_medium'
import flying_money from './flying_money'
import flying_money_medium from './flying_money_medium'
import folder from './folder'
import folder_medium from './folder_medium'
import fortune_ball from './fortune_ball'
import fortune_ball_medium from './fortune_ball_medium'
import fridge from './fridge'
import fridge_medium from './fridge_medium'
import fullscreen from './fullscreen'
import fullscreen_medium from './fullscreen_medium'
import funds from './funds'
import funds_in from './funds_in'
import funds_in_medium from './funds_in_medium'
import funds_medium from './funds_medium'
import funds_out from './funds_out'
import funds_out_medium from './funds_out_medium'
import globe from './globe'
import globe_medium from './globe_medium'
import goal from './goal'
import goal_medium from './goal_medium'
import grabber from './grabber'
import grabber_medium from './grabber_medium'
import graph_decrease from './graph_decrease'
import graph_decrease_medium from './graph_decrease_medium'
import graph_increase from './graph_increase'
import graph_increase_medium from './graph_increase_medium'
import hamburger from './hamburger'
import hamburger_medium from './hamburger_medium'
import hand_money from './hand_money'
import hand_money_medium from './hand_money_medium'
import handshake from './handshake'
import handshake_medium from './handshake_medium'
import hanger from './hanger'
import hanger_medium from './hanger_medium'
import heart from './heart'
import heart_medium from './heart_medium'
import heart_rate from './heart_rate'
import heart_rate_medium from './heart_rate_medium'
import heavy_equipment from './heavy_equipment'
import heavy_equipment_medium from './heavy_equipment_medium'
import hide from './hide'
import hide_medium from './hide_medium'
import hierarchy from './hierarchy'
import hierarchy_medium from './hierarchy_medium'
import history from './history'
import history_medium from './history_medium'
import home from './home'
import home_medium from './home_medium'
import horse from './horse'
import horse_medium from './horse_medium'
import hourglass from './hourglass'
import hourglass_medium from './hourglass_medium'
import house_1 from './house_1'
import house_1_medium from './house_1_medium'
import house_2 from './house_2'
import house_2_medium from './house_2_medium'
import house_value from './house_value'
import house_value_medium from './house_value_medium'
import id_card from './id_card'
import id_card_medium from './id_card_medium'
import information from './information'
import information_bubble from './information_bubble'
import information_bubble_medium from './information_bubble_medium'
import information_circled from './information_circled'
import information_circled_medium from './information_circled_medium'
import information_medium from './information_medium'
import instagram from './instagram'
import instagram_medium from './instagram_medium'
import insurance from './insurance'
import insurance_medium from './insurance_medium'
import investment_account from './investment_account'
import investment_account_medium from './investment_account_medium'
import investor from './investor'
import investor_medium from './investor_medium'
import keyfigures from './keyfigures'
import keyfigures_medium from './keyfigures_medium'
import kid_number from './kid_number'
import kid_number_medium from './kid_number_medium'
import language from './language'
import language_medium from './language_medium'
import laptop from './laptop'
import laptop_medium from './laptop_medium'
import launch from './launch'
import launch_medium from './launch_medium'
import layout_card from './layout_card'
import layout_card_medium from './layout_card_medium'
import layout_grid from './layout_grid'
import layout_grid_medium from './layout_grid_medium'
import leaf from './leaf'
import leaf_medium from './leaf_medium'
import lightbulb from './lightbulb'
import lightbulb_medium from './lightbulb_medium'
import lightningstrike from './lightningstrike'
import lightningstrike_medium from './lightningstrike_medium'
import linkedin from './linkedin'
import linkedin_medium from './linkedin_medium'
import list from './list'
import list_medium from './list_medium'
import loan from './loan'
import loan_in from './loan_in'
import loan_in_medium from './loan_in_medium'
import loan_medium from './loan_medium'
import loan_out from './loan_out'
import loan_out_medium from './loan_out_medium'
import location from './location'
import location_medium from './location_medium'
import log_in from './log_in'
import log_in_medium from './log_in_medium'
import log_out from './log_out'
import log_out_medium from './log_out_medium'
import loupe from './loupe'
import loupe_medium from './loupe_medium'
import mastercard from './mastercard'
import mastercard_card from './mastercard_card'
import mastercard_card_medium from './mastercard_card_medium'
import mastercard_medium from './mastercard_medium'
import megaphone from './megaphone'
import megaphone_medium from './megaphone_medium'
import microphone from './microphone'
import microphone_medium from './microphone_medium'
import minimize from './minimize'
import minimize_medium from './minimize_medium'
import mobile from './mobile'
import mobile_medium from './mobile_medium'
import mobilephone from './mobilephone'
import mobilephone_medium from './mobilephone_medium'
import money_left from './money_left'
import money_left_medium from './money_left_medium'
import more from './more'
import more_medium from './more_medium'
import more_vertical from './more_vertical'
import more_vertical_medium from './more_vertical_medium'
import motorcycle from './motorcycle'
import motorcycle_medium from './motorcycle_medium'
import move from './move'
import move_medium from './move_medium'
import news from './news'
import news_medium from './news_medium'
import newspaper from './newspaper'
import newspaper_medium from './newspaper_medium'
import office_buildings from './office_buildings'
import office_buildings_medium from './office_buildings_medium'
import oil from './oil'
import oil_medium from './oil_medium'
import owl from './owl'
import owl_medium from './owl_medium'
import padlock from './padlock'
import padlock_medium from './padlock_medium'
import paperclip from './paperclip'
import paperclip_medium from './paperclip_medium'
import paragraph from './paragraph'
import paragraph_medium from './paragraph_medium'
import pause from './pause'
import pause_medium from './pause_medium'
import pay_from from './pay_from'
import pay_from_medium from './pay_from_medium'
import pension from './pension'
import pension_medium from './pension_medium'
import people_1 from './people_1'
import people_1_medium from './people_1_medium'
import people_2 from './people_2'
import people_2_medium from './people_2_medium'
import person from './person'
import person_medium from './person_medium'
import person_shield from './person_shield'
import person_shield_medium from './person_shield_medium'
import phone from './phone'
import phone_medium from './phone_medium'
import photo from './photo'
import photo_medium from './photo_medium'
import pin from './pin'
import pin_code from './pin_code'
import pin_code_medium from './pin_code_medium'
import pin_medium from './pin_medium'
import plant from './plant'
import plant_medium from './plant_medium'
import play from './play'
import play_medium from './play_medium'
import podcast from './podcast'
import podcast_medium from './podcast_medium'
import portfolio_analytics from './portfolio_analytics'
import portfolio_analytics_medium from './portfolio_analytics_medium'
import printer from './printer'
import printer_medium from './printer_medium'
import profile from './profile'
import profile_medium from './profile_medium'
import progress from './progress'
import progress_medium from './progress_medium'
import question from './question'
import question_circled from './question_circled'
import question_circled_medium from './question_circled_medium'
import question_medium from './question_medium'
import recurring from './recurring'
import recurring_medium from './recurring_medium'
import redo from './redo'
import redo_medium from './redo_medium'
import ref_number from './ref_number'
import ref_number_medium from './ref_number_medium'
import refresh from './refresh'
import refresh_medium from './refresh_medium'
import reply from './reply'
import reply_medium from './reply_medium'
import reset from './reset'
import reset_medium from './reset_medium'
import restaurant from './restaurant'
import restaurant_medium from './restaurant_medium'
import return_1 from './return_1'
import return_1_medium from './return_1_medium'
import save from './save'
import save_medium from './save_medium'
import savings_account from './savings_account'
import savings_account_in from './savings_account_in'
import savings_account_in_medium from './savings_account_in_medium'
import savings_account_medium from './savings_account_medium'
import savings_account_out from './savings_account_out'
import savings_account_out_medium from './savings_account_out_medium'
import scan from './scan'
import scan_medium from './scan_medium'
import scissors from './scissors'
import scissors_medium from './scissors_medium'
import scooter from './scooter'
import scooter_medium from './scooter_medium'
import sea_transport from './sea_transport'
import sea_transport_medium from './sea_transport_medium'
import send from './send'
import send_medium from './send_medium'
import share_android from './share_android'
import share_android_medium from './share_android_medium'
import share_ios from './share_ios'
import share_ios_medium from './share_ios_medium'
import shield from './shield'
import shield_lock from './shield_lock'
import shield_lock_medium from './shield_lock_medium'
import shield_medium from './shield_medium'
import shopping_cart from './shopping_cart'
import shopping_cart_medium from './shopping_cart_medium'
import show_pin from './show_pin'
import show_pin_medium from './show_pin_medium'
import snowmobile from './snowmobile'
import snowmobile_medium from './snowmobile_medium'
import sort from './sort'
import sort_medium from './sort_medium'
import speedometer from './speedometer'
import speedometer_medium from './speedometer_medium'
import split from './split'
import split_medium from './split_medium'
import star from './star'
import star_medium from './star_medium'
import stocks from './stocks'
import stocks_medium from './stocks_medium'
import stop from './stop'
import stop_medium from './stop_medium'
import stopwatch from './stopwatch'
import stopwatch_medium from './stopwatch_medium'
import subtract from './subtract'
import subtract_circled from './subtract_circled'
import subtract_circled_medium from './subtract_circled_medium'
import subtract_medium from './subtract_medium'
import support from './support'
import support_medium from './support_medium'
import swap from './swap'
import swap_medium from './swap_medium'
import table from './table'
import table_medium from './table_medium'
import tag from './tag'
import tag_medium from './tag_medium'
import teenager from './teenager'
import teenager_medium from './teenager_medium'
import thumbs_down from './thumbs_down'
import thumbs_down_medium from './thumbs_down_medium'
import thumbs_up from './thumbs_up'
import thumbs_up_medium from './thumbs_up_medium'
import tractor from './tractor'
import tractor_medium from './tractor_medium'
import trailer from './trailer'
import trailer_medium from './trailer_medium'
import train from './train'
import train_medium from './train_medium'
import transfer from './transfer'
import transfer_medium from './transfer_medium'
import transfer_to from './transfer_to'
import transfer_to_medium from './transfer_to_medium'
import trash from './trash'
import trash_medium from './trash_medium'
import travel from './travel'
import travel_medium from './travel_medium'
import undo from './undo'
import undo_medium from './undo_medium'
import unlock from './unlock'
import unlock_medium from './unlock_medium'
import upload from './upload'
import upload_medium from './upload_medium'
import user_feedback from './user_feedback'
import user_feedback_medium from './user_feedback_medium'
import video from './video'
import video_medium from './video_medium'
import view from './view'
import view_medium from './view_medium'
import vintage_car from './vintage_car'
import vintage_car_medium from './vintage_car_medium'
import volume_off from './volume_off'
import volume_off_medium from './volume_off_medium'
import volume_on from './volume_on'
import volume_on_medium from './volume_on_medium'
import wallet from './wallet'
import wallet_medium from './wallet_medium'
import wearables from './wearables'
import wearables_medium from './wearables_medium'
import web from './web'
import web_medium from './web_medium'
import wheelchair from './wheelchair'
import wheelchair_medium from './wheelchair_medium'
import widget_android from './widget_android'
import widget_android_medium from './widget_android_medium'
import widget_ios from './widget_ios'
import widget_ios_medium from './widget_ios_medium'

export {
  above_the_line,
  above_the_line_medium,
  account,
  account_card,
  account_card_medium,
  account_in,
  account_in_medium,
  account_medium,
  account_out,
  account_out_medium,
  account_percent,
  account_percent_medium,
  accounting,
  accounting_medium,
  add,
  add_circled,
  add_circled_medium,
  add_medium,
  aino,
  aino_medium,
  ainvoice,
  ainvoice_medium,
  ambulance,
  ambulance_medium,
  animal_print,
  animal_print_medium,
  apple_watch,
  apple_watch_medium,
  arrow_down,
  arrow_down_medium,
  arrow_left,
  arrow_left_medium,
  arrow_right,
  arrow_right_medium,
  arrow_up,
  arrow_up_medium,
  attachment,
  attachment_medium,
  baby,
  baby_medium,
  bandage,
  bandage_medium,
  bank,
  bank_medium,
  bankid,
  bankid_medium,
  bankid_mobile,
  bankid_mobile_medium,
  bankid_qr,
  bankid_qr_medium,
  bell,
  bell_medium,
  bicycle,
  bicycle_medium,
  boat,
  boat_medium,
  bookmark,
  bookmark_medium,
  bowling,
  bowling_medium,
  brickwall,
  brickwall_medium,
  broken_chain,
  broken_chain_medium,
  browser,
  browser_medium,
  brush,
  brush_medium,
  bsu,
  bsu_medium,
  bubble,
  bubble_medium,
  building_construction,
  building_construction_medium,
  building_shopping,
  building_shopping_medium,
  bus,
  bus_medium,
  calculator,
  calculator_medium,
  calendar,
  calendar_add,
  calendar_add_medium,
  calendar_cancel,
  calendar_cancel_medium,
  calendar_medium,
  camera,
  camera_medium,
  camper_trailer,
  camper_trailer_medium,
  candle_stick,
  candle_stick_medium,
  car_1,
  car_1_medium,
  car_2,
  car_2_medium,
  caravan,
  caravan_medium,
  card,
  card_in,
  card_in_medium,
  card_medium,
  card_out,
  card_out_medium,
  card_with_padlock,
  card_with_padlock_medium,
  cat,
  cat_medium,
  chain,
  chain_medium,
  charger,
  charger_medium,
  chat,
  chat_medium,
  chatbot,
  chatbot_medium,
  check,
  check_medium,
  chevron_down,
  chevron_down_medium,
  chevron_left,
  chevron_left_medium,
  chevron_right,
  chevron_right_medium,
  chevron_up,
  chevron_up_medium,
  chip,
  chip_medium,
  clock,
  clock_medium,
  close,
  close_medium,
  cloud,
  cloud_download,
  cloud_download_medium,
  cloud_medium,
  cloud_rain,
  cloud_rain_medium,
  cloud_sync,
  cloud_sync_medium,
  cloud_transfer,
  cloud_transfer_medium,
  cloud_upload,
  cloud_upload_medium,
  cog,
  cog_medium,
  coins_1,
  coins_1_medium,
  coins_2,
  coins_2_medium,
  coins_3,
  coins_3_medium,
  compose,
  compose_medium,
  confetti,
  confetti_medium,
  contacts,
  contacts_medium,
  cookie,
  cookie_medium,
  copy,
  copy_medium,
  credit_note,
  credit_note_medium,
  currency,
  currency_medium,
  customer_service,
  customer_service_medium,
  deleted_invoice,
  deleted_invoice_medium,
  diamond,
  diamond_medium,
  digipass,
  digipass_corporate,
  digipass_corporate_medium,
  digipass_medium,
  digipass_private,
  digipass_private_medium,
  digipost,
  digipost_medium,
  digital_advise,
  digital_advise_medium,
  digitpass_private_corporate,
  digitpass_private_corporate_medium,
  dismiss_keyboard,
  dismiss_keyboard_medium,
  dog,
  dog_medium,
  download,
  download_medium,
  e_scooter,
  e_scooter_medium,
  edit,
  edit_medium,
  einvoice,
  einvoice_medium,
  email,
  email_medium,
  envelope_open,
  envelope_open_medium,
  equities_and_mutual_funds,
  equities_and_mutual_funds_medium,
  exclamation,
  exclamation_circled,
  exclamation_circled_medium,
  exclamation_medium,
  exclamation_triangle,
  exclamation_triangle_medium,
  facebook,
  facebook_medium,
  factory,
  factory_medium,
  file,
  file_add,
  file_add_medium,
  file_contract,
  file_contract_medium,
  file_csv,
  file_csv_medium,
  file_jpg,
  file_jpg_medium,
  file_loupe,
  file_loupe_medium,
  file_medium,
  file_pdf,
  file_pdf_medium,
  file_png,
  file_png_medium,
  file_ppt,
  file_ppt_medium,
  file_rejected,
  file_rejected_medium,
  file_signing,
  file_signing_medium,
  file_txt,
  file_txt_medium,
  file_warning,
  file_warning_medium,
  file_word,
  file_word_medium,
  file_xls,
  file_xls_medium,
  file_xml,
  file_xml_medium,
  file_zip,
  file_zip_medium,
  filter,
  filter_medium,
  first_aid,
  first_aid_medium,
  fish,
  fish_medium,
  flying_money,
  flying_money_medium,
  folder,
  folder_medium,
  fortune_ball,
  fortune_ball_medium,
  fridge,
  fridge_medium,
  fullscreen,
  fullscreen_medium,
  funds,
  funds_in,
  funds_in_medium,
  funds_medium,
  funds_out,
  funds_out_medium,
  globe,
  globe_medium,
  goal,
  goal_medium,
  grabber,
  grabber_medium,
  graph_decrease,
  graph_decrease_medium,
  graph_increase,
  graph_increase_medium,
  hamburger,
  hamburger_medium,
  hand_money,
  hand_money_medium,
  handshake,
  handshake_medium,
  hanger,
  hanger_medium,
  heart,
  heart_medium,
  heart_rate,
  heart_rate_medium,
  heavy_equipment,
  heavy_equipment_medium,
  hide,
  hide_medium,
  hierarchy,
  hierarchy_medium,
  history,
  history_medium,
  home,
  home_medium,
  horse,
  horse_medium,
  hourglass,
  hourglass_medium,
  house_1,
  house_1_medium,
  house_2,
  house_2_medium,
  house_value,
  house_value_medium,
  id_card,
  id_card_medium,
  information,
  information_bubble,
  information_bubble_medium,
  information_circled,
  information_circled_medium,
  information_medium,
  instagram,
  instagram_medium,
  insurance,
  insurance_medium,
  investment_account,
  investment_account_medium,
  investor,
  investor_medium,
  keyfigures,
  keyfigures_medium,
  kid_number,
  kid_number_medium,
  language,
  language_medium,
  laptop,
  laptop_medium,
  launch,
  launch_medium,
  layout_card,
  layout_card_medium,
  layout_grid,
  layout_grid_medium,
  leaf,
  leaf_medium,
  lightbulb,
  lightbulb_medium,
  lightningstrike,
  lightningstrike_medium,
  linkedin,
  linkedin_medium,
  list,
  list_medium,
  loan,
  loan_in,
  loan_in_medium,
  loan_medium,
  loan_out,
  loan_out_medium,
  location,
  location_medium,
  log_in,
  log_in_medium,
  log_out,
  log_out_medium,
  loupe,
  loupe_medium,
  mastercard,
  mastercard_card,
  mastercard_card_medium,
  mastercard_medium,
  megaphone,
  megaphone_medium,
  microphone,
  microphone_medium,
  minimize,
  minimize_medium,
  mobile,
  mobile_medium,
  mobilephone,
  mobilephone_medium,
  money_left,
  money_left_medium,
  more,
  more_medium,
  more_vertical,
  more_vertical_medium,
  motorcycle,
  motorcycle_medium,
  move,
  move_medium,
  news,
  news_medium,
  newspaper,
  newspaper_medium,
  office_buildings,
  office_buildings_medium,
  oil,
  oil_medium,
  owl,
  owl_medium,
  padlock,
  padlock_medium,
  paperclip,
  paperclip_medium,
  paragraph,
  paragraph_medium,
  pause,
  pause_medium,
  pay_from,
  pay_from_medium,
  pension,
  pension_medium,
  people_1,
  people_1_medium,
  people_2,
  people_2_medium,
  person,
  person_medium,
  person_shield,
  person_shield_medium,
  phone,
  phone_medium,
  photo,
  photo_medium,
  pin,
  pin_code,
  pin_code_medium,
  pin_medium,
  plant,
  plant_medium,
  play,
  play_medium,
  podcast,
  podcast_medium,
  portfolio_analytics,
  portfolio_analytics_medium,
  printer,
  printer_medium,
  profile,
  profile_medium,
  progress,
  progress_medium,
  question,
  question_circled,
  question_circled_medium,
  question_medium,
  recurring,
  recurring_medium,
  redo,
  redo_medium,
  ref_number,
  ref_number_medium,
  refresh,
  refresh_medium,
  reply,
  reply_medium,
  reset,
  reset_medium,
  restaurant,
  restaurant_medium,
  return_1,
  return_1_medium,
  save,
  save_medium,
  savings_account,
  savings_account_in,
  savings_account_in_medium,
  savings_account_medium,
  savings_account_out,
  savings_account_out_medium,
  scan,
  scan_medium,
  scissors,
  scissors_medium,
  scooter,
  scooter_medium,
  sea_transport,
  sea_transport_medium,
  send,
  send_medium,
  share_android,
  share_android_medium,
  share_ios,
  share_ios_medium,
  shield,
  shield_lock,
  shield_lock_medium,
  shield_medium,
  shopping_cart,
  shopping_cart_medium,
  show_pin,
  show_pin_medium,
  snowmobile,
  snowmobile_medium,
  sort,
  sort_medium,
  speedometer,
  speedometer_medium,
  split,
  split_medium,
  star,
  star_medium,
  stocks,
  stocks_medium,
  stop,
  stop_medium,
  stopwatch,
  stopwatch_medium,
  subtract,
  subtract_circled,
  subtract_circled_medium,
  subtract_medium,
  support,
  support_medium,
  swap,
  swap_medium,
  table,
  table_medium,
  tag,
  tag_medium,
  teenager,
  teenager_medium,
  thumbs_down,
  thumbs_down_medium,
  thumbs_up,
  thumbs_up_medium,
  tractor,
  tractor_medium,
  trailer,
  trailer_medium,
  train,
  train_medium,
  transfer,
  transfer_medium,
  transfer_to,
  transfer_to_medium,
  trash,
  trash_medium,
  travel,
  travel_medium,
  undo,
  undo_medium,
  unlock,
  unlock_medium,
  upload,
  upload_medium,
  user_feedback,
  user_feedback_medium,
  video,
  video_medium,
  view,
  view_medium,
  vintage_car,
  vintage_car_medium,
  volume_off,
  volume_off_medium,
  volume_on,
  volume_on_medium,
  wallet,
  wallet_medium,
  wearables,
  wearables_medium,
  web,
  web_medium,
  wheelchair,
  wheelchair_medium,
  widget_android,
  widget_android_medium,
  widget_ios,
  widget_ios_medium,
}
